



































































































import { Component, Vue } from "vue-property-decorator";
import { Crops } from "@/patchConstants";
import { range } from "@/utils";

const STORAGE_AUTH_KEY = "submissionApiKey";

const DATE_FORMAT = new Intl.DateTimeFormat("en-GB", {
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "numeric",
  minute: "numeric",
});

interface Terrain {
  value: string | null;
  label: string;
}

@Component
export default class Submit extends Vue {
  private authkey = localStorage.getItem(STORAGE_AUTH_KEY) || "";

  private terrains: Terrain[] = [
    {
      label: "Wingfield",
      value: "wingfield",
    },
    {
      label: "PFAF",
      value: "pfaf",
    },
    {
      label: "Kestle Barton",
      value: "kestlebarton",
    },
    {
      label: "Hyde Park",
      value: "hydepark",
    },
    {
      label: "Nottingham (Z-Mapping)",
      value: "nottingham",
    },
    {
      label: "Lerchesgade Paul",
      value: "lerchesgadepaul",
    },
    {
      label: "CUSTOM",
      value: null,
    },
  ];

  private payload = {
    density: 2,
    frost_zone: 7,
    crop_tags: [],
    is_bees: true,
    is_native: true,
    name: "",
    rainfall_annual: 1000,
    soil_ph: "7",
    soil_type: "light",
    terrain: this.terrains[0].value,
    description: "",
  };

  private nameEdited = false;
  private get patchName() {
    if (this.nameEdited) {
      return this.payload.name;
    } else {
      let terrainDisplay = this.payload.terrain || this.customTerrain;
      if (terrainDisplay.startsWith("http")) {
        terrainDisplay = "CUSTOM URL";
      }
      return `Untitled Design (${
        terrainDisplay || "???"
      }) - ${DATE_FORMAT.format(new Date())}`;
    }
  }

  private set patchName(val: string) {
    this.nameEdited = true;
    this.payload.name = val;
  }

  private customTerrain = "";

  private get cropOptions() {
    return Crops;
  }

  private get phOptions() {
    return range(3.5, 8, 0.5);
  }

  private getRainfallDisplay(mm: number) {
    if (mm <= 1000) {
      return "Dry";
    }
    if (mm <= 2000) {
      return "Medium";
    }
    return "Wet";
  }

  private submit() {
    fetch(`/api/patches?authkey=${this.authkey}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...this.payload,
        name: this.patchName,
        terrain: this.payload.terrain || this.customTerrain,
        soil_ph: parseInt(this.payload.soil_ph),
      }),
    }).then(async (response) => {
      if (response.ok) {
        localStorage.setItem(STORAGE_AUTH_KEY, this.authkey);
        const location = {
          name: "patch",
          params: {
            id: (await response.json())["data"]["id"],
          },
        };
        await this.$router.push(location);
      } else {
        alert(`${response.statusText}\n\n${await response.text()}`);
      }
    });
  }
}
